import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";
export interface UserState {
  isUserAuthenticated: boolean;
  role: string;
  userId: string;
  hasAdminAccess: boolean;
  hasMasterAdminAccess: boolean;
  hasHealthCoachAccess: boolean;
  hasClinicalAssistantAccess: boolean;
}

const initialState: UserState = {
  isUserAuthenticated: false,
  role: "",
  userId: "",
  hasAdminAccess: false,
  hasMasterAdminAccess: false,
  hasHealthCoachAccess: false,
  hasClinicalAssistantAccess: false,
};

const getIntialState = (): UserState => {
  let isUserAuthenticated = false;
  let role = "";
  let userId = "";
  let hasAdminAccess = false;
  let hasMasterAdminAccess = false;
  let hasHealthCoachAccess = false;
  let hasClinicalAssistantAccess = false;
  const token = localStorage.getItem("cadence-access-token") || "";
  if (token) {
    try {
      const decoded: any = jwt_decode(token);
      isUserAuthenticated = true;
      userId = decoded.id;
      role = decoded.role;
      hasAdminAccess = ["master_admin", "admin"].includes(role);
      hasMasterAdminAccess = ["master_admin"].includes(role);
      hasHealthCoachAccess = ["coach"].includes(role);
      hasClinicalAssistantAccess = ["clinical_assistant"].includes(role);
    } catch (err) {}
  }
  return {
    ...initialState,
    isUserAuthenticated: isUserAuthenticated,
    hasAdminAccess: hasAdminAccess,
    hasMasterAdminAccess: hasMasterAdminAccess,
    hasHealthCoachAccess: hasHealthCoachAccess,
    hasClinicalAssistantAccess: hasClinicalAssistantAccess,
    role: role,
    userId: userId,
  };
};

export const userSlice = createSlice({
  name: "user",
  initialState: getIntialState,
  reducers: {
    setUserAuth: (
      state,
      action: PayloadAction<{
        authenticated: boolean;
        role: string;
        userId: string;
      }>
    ) => {
      state.role = action.payload.role;
      state.userId = action.payload.userId;
      state.isUserAuthenticated = action.payload.authenticated;
      state.hasAdminAccess = ["master_admin", "admin"].includes(
        action.payload.role
      );
      state.hasMasterAdminAccess = ["master_admin"].includes(
        action.payload.role
      );
      state.hasHealthCoachAccess = ["coach"].includes(action.payload.role);

      state.hasClinicalAssistantAccess = ["clinical_assistant"].includes(
        action.payload.role
      );
    },
    reset: () => initialState,
  },
});

export const { setUserAuth, reset } = userSlice.actions;

export default userSlice.reducer;
